import type { AxiosInstance } from "axios";
import type CustomerId from "../state/CustomerId";
import { useClient } from "../state/client";
import { initialized } from "../utils/initializedUtil";
import { minutes } from "../utils/timeUtil";
import { API_BASE_URL } from "../constants";
import type { SecureUriDto } from "./CustomerResourceService";
import { useQueryClient } from "@tanstack/solid-query";

let client: AxiosInstance | null = null;
let customerId: CustomerId | null = null;

const init = (cusId: CustomerId): void => {
  customerId = cusId;
  client = useClient();
};

const getClient = () => initialized(client, "client");

const getSecureUri = async (registrationFileId: string) => {
  const { data } = await getClient().get<SecureUriDto>(
    `/api/v1.0/customers/${customerId}/registrationFile/${registrationFileId}`,
  );
  return `${API_BASE_URL}/api/v1.0/downloads/secured?${data.secureUri}`;
};

const CustomerRegistrationFileService = {
  getSecureUri: (registrationFileId: string) =>
    useQueryClient().ensureQueryData({
      queryKey: [registrationFileId],
      queryFn: async () => getSecureUri(registrationFileId),
      staleTime: minutes(25), // Link is valid for 30 minutes, make stale just before
    }),
  init: init,
};

export default CustomerRegistrationFileService;
